export const CREATE_DMX_DEVICE = 'CREATE_DMX_DEVICE';
export const CREATE_DMX_DEVICE_SUCCESSFUL = 'CREATE_DMX_DEVICE_SUCCESSFUL';
export const CREATE_DMX_DEVICE_FAILED = 'CREATE_DMX_DEVICE_FAILED';
